<template lang="html">

  <form id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required'" name="nombre" placeholder="Nombre y Apellidos*" />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>

    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required|email'" name="email" placeholder="Email*" />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>
    <div class="contenedor-input">
      <input type="text" class="input-text" name="telefono" placeholder="Télefono" />
      <span :class="['error', { 'animated shake': clicked }]" </span>
    </div>

    <div class="contenedor-input">
      <textarea placeholder="Mensaje*" name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('mensaje') }}</span>
    </div>

    <div class="contenedor-input policy">
      <input name="politica" type="checkbox" id="politica" value="politica" v-validate="'required'">
      <label for="politica">Acepto la <u><router-link to="/politica-de-privacidad">Política de
            Privacidad</router-link></u></label>
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <input type="hidden" name="from" value="web">


    <button :enviado="enviado" class="btn row-center" :loading="loading"
      :disabled="loading"><span>¿Hablamos?</span></button>
    <p :enviado="enviado" class="gracias">¡Gracias!<br>
      Nos pondremos en contacto contigo lo antes posible. </p>
    <p class="error" v-if="error">
      Hubo un problema al enviar el mensaje. Intenta nuevamente.
    </p>
  </form>

</template>

<script lang="js">


import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'formulario',
  props: [],
  mounted() {

  },
  data() {
    return {
      clicked: false,
      loading: false,
      enviado: false,
      error: false
    }
  },
  methods: {
    ...mapActions(['sendContacto']),
    validateBeforeSubmit: function () {
      this.clicked = true;
      this.$validator.validateAll().then(canSend => {
        if (canSend) {
          this.loading = true;
          this.sendContacto($("#formContacto").serialize())
            .then(result => {
              setTimeout(() => {
                this.loading = false;
                this.enviado = true;
                $("#formContacto")[0].reset();
              }, 1000);
            }).catch(() => {
              setTimeout(() => {
                this.loading = false;
                this.enviado = false;
                this.error = true;
                $("#formContacto")[0].reset();
              }, 1000);
            });
          setTimeout(() => {
            this.error = false;
            this.enviado = false;
          }, 5000);
        }
      });
    },

  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
.formulario {
  #formContacto {
    position: relative;
    width: 100%;

    .contenedor-input {
      &.policy {
        margin: 30px 0 10px 0;
        text-align: left;

        input {
          margin-bottom: 0;

          &:focus {
            border: 1px solid black;
          }
        }

        label {
          cursor: pointer;
        }
      }

      input,
      textarea {
        width: 100%;
        border: none;
        border-bottom: 1px solid black;
        padding: 35px 0 15px 0;
        font-size: 18px;
        background: transparent;
        margin-bottom: 5px;

        @media screen and(max-width:600px) {
          font-size: 16px;
        }

        &[type="checkbox"] {
          border: 1px solid black;
          width: 15px;
          height: 15px;
          padding: 0;
        }

        &:checked {
          background: url("/static/img/tick-pink.svg");
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 80%;
        }

        &:focus {
          border: none;
          outline: none;
          border-bottom: 1px solid black;
        }
      }

      textarea {
        height: 175px;
      }

      ::placeholder {
        color: gray;
        font-size: 18px;

        @media screen and(max-width:600px) {
          font-size: 16px;
        }
      }

      label {
        color: black;
        font-size: 16px;
        font-weight: bold;

      }

      .small {
        width: 96%;
        font-size: 11px;
        margin-left: 19px;
        line-height: 16px;
        margin-top: 9px;
        color: gray;

        @media (max-width: 1280px) {
          margin-left: 0px;
        }

        a {
          text-decoration: underline;
        }
      }

      .error {
        color: #de0a2f;
        top: 0;
        left: 5px;
        position: relative;
        font-weight: bold;
        font-size: 15px;
        text-align: left;
        width: 100%;
        float: left;
      }
    }

    .gracias {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 55px;
      text-align: left;
      width: 100%;
      opacity: 0;
      pointer-events: none;
      color: #8bc34a;
      font-weight: bold;
      font-family: "GothamBold";
      text-transform: uppercase;
      font-size: 18px;
      line-height: 25px;
      transition: opacity 0.5s ease-in-out;
      -moz-transition: opacity 0.5s ease-in-out;
      -webkit-transition: opacity 0.5s ease-in-out;
    }

    .gracias[enviado="true"] {
      opacity: 1;
      transition: opacity 0.5s ease-in-out;
      -moz-transition: opacity 0.5s ease-in-out;
      -webkit-transition: opacity 0.5s ease-in-out;
    }
    .error {
      height: 55px;
      text-align: left;
      width: 100%;
      opacity: 0;
      pointer-events: none;
      color: #dd1616;
      font-weight: bold;
      font-family: "GothamBold";
      text-transform: uppercase;
      font-size: 18px;
      line-height: 25px;
      transition: opacity 0.5s ease-in-out;
      -moz-transition: opacity 0.5s ease-in-out;
      -webkit-transition: opacity 0.5s ease-in-out;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/formulario.vue